module.exports = __webpack_public_path__ + "img/zh_sgyl.0bd0c8ad.svg";